import { TEXT } from './00_assets_types'

const ES =
{
  [ TEXT.UI_MENU_USERS         ]: 'Erabiltzaileak'
, [ TEXT.UI_MENU_CLIENTS       ]: 'Bezeroak'
, [ TEXT.UI_MENU_WORKGROUPS    ]: 'Lan taldeak'
, [ TEXT.UI_MENU_JOBS          ]: 'Atazak'
, [ TEXT.UI_MENU_KEY_MASTERING  ]: 'Amaestramentuak'

, [ TEXT.UI_BUTTON_CREATE      ]: 'Sortu'
, [ TEXT.UI_BUTTON_NEW         ]: 'Berria'
, [ TEXT.UI_BUTTON_OK          ]: 'Onartu'
, [ TEXT.UI_BUTTON_CANCEL      ]: 'Atzera'
, [ TEXT.UI_BUTTON_SAVE        ]: 'Gorde'
, [ TEXT.UI_BUTTON_LOGIN       ]: 'Sartu'
, [ TEXT.UI_BUTTON_SEND        ]: 'Bidali'


, [ TEXT.UI_EMAIL              ]: 'E-posta'
, [ TEXT.UI_ROLE               ]: 'Perfila'
, [ TEXT.UI_USERNAME           ]: 'Erabiltzailea'
, [ TEXT.UI_NAME               ]: 'Izena'
, [ TEXT.UI_DATE               ]: 'Data'
, [ TEXT.UI_ADDR               ]: 'Tokia'
, [ TEXT.UI_DESC               ]: 'Deskribapena'
, [ TEXT.UI_PRICE              ]: 'Prezioa'
, [ TEXT.UI_NO_DATA            ]: 'Ez dago daturik'
, [ TEXT.UI_MACHINES           ]: 'Makinak'
, [ TEXT.UI_USERS              ]: 'Erabiltzaileak'
, [ TEXT.UI_DATE_FORMAT        ]: 'YYYY/MM/DD' // EU - date format Locale
, [ TEXT.UI_SING_OUT           ]: 'Irten'
, [ TEXT.UI_MKS_TYPE           ]: 'Amaestramendu mota'
, [ TEXT.UI_KEY_APP            ]: 'Erabilera'
, [ TEXT.UI_CLIENT             ]: 'Bezeroa'
, [ TEXT.UI_FILE               ]: 'Fitxategia'
, [ TEXT.UI_SELECT_FILE        ]: 'Aukeratu fitxategia'


, [ TEXT.UI_LOGIN_USERNAME     ]: 'Erabiltzailea'
, [ TEXT.UI_LOGIN_CLOUDNAME    ]: 'Cloud izena'
, [ TEXT.UI_LOGIN_PASSWORD     ]: 'Pasahitza'



, [ TEXT.ARE_YOU_SURE          ]: '¿Seguru zaude?'


, [ TEXT.ERROR_NONE            ]: ''
, [ TEXT.ERROR_LOGIN_FORBIDDEN ]: 'Cloud, erabiltzaile edo pasahitza ez dira zuzenak'
, [ TEXT.ERROR_LOGIN_UNAUTHORIZED ]: 'Cloud, erabiltzaile edo pasahitza ez dira zuzenak'
, [ TEXT.ERROR_INTERNAL        ]: 'Errorea zerbitzarian'
, [ TEXT.ERROR_FORBIDDEN       ]: 'Sarrera debekatua'
, [ TEXT.ERROR_UNKNOWN         ]: 'Arazo ezezagun bat egon da'

, [ TEXT.PAGE_NOT_FOUND        ]: 'Ezin izan da orria aurkitu'

, [ TEXT.WORKGROUPS_NEW_TITLE  ]: 'Talde berria'
, [ TEXT.WORKGROUPS_EDIT_TITLE ]: 'Taldea editatu'
, [ TEXT.WORKGROUPS_NAME       ]: 'Talde izena'


, [ TEXT.USERS_NEW_TITLE       ]: 'Erabiltzaile berria'
, [ TEXT.USERS_EDIT_TITLE      ]: 'Erabiltzailea editatu'

, [ TEXT.MACHINE_TYPE          ]: 'Makina mota'
, [ TEXT.MACHINE_NUM_JOBS      ]: 'Ataza kop.'
, [ TEXT.MACHINE_NAME          ]: 'Makina'

, [ TEXT.CLIENT_NEW_TITLE      ]: 'Bezero berria'
, [ TEXT.CLIENT_EDIT_TITLE     ]: 'Bezeroa editatu'
, [ TEXT.CLIENT_ADDRESS        ]: 'Helbidea'
, [ TEXT.CLIENT_CONTACT        ]: 'Kontaktua'
, [ TEXT.CLIENT_CONTACT_EMAIL  ]: 'E-posta'
, [ TEXT.CLIENT_CONTACT_PHONE  ]: 'Telefonoa'
, [ TEXT.CLIENT_CONTACT_FAX    ]: 'Fax/Tlf'
, [ TEXT.CLIENT_SURNAMES       ]: 'Abizenak'
, [ TEXT.CLIENT_BIRTHDAY       ]: 'Jaiotze data'
, [ TEXT.CLIENT_NOTES          ]: 'Notak'
, [ TEXT.CLIENTS_FILTER_BY_NAME ]: 'Izena filtratu'
, [ TEXT.CLIENTS_FILTER_BY_ADDR ]: 'Helbidea filtratu'
, [ TEXT.CLIENTS_FILTER_BY_CONTACT ]: 'Kontaktua filtratu'
, [ TEXT.CLIENT_ADDR_STREET1   ]: 'Kalea'
, [ TEXT.CLIENT_ADDR_STREET2   ]: ''
, [ TEXT.CLIENT_ADDR_CITY      ]: 'Herria'
, [ TEXT.CLIENT_ADDR_PROVINCE  ]: 'Probintzia'
, [ TEXT.CLIENT_ADDR_ZIP_CODE  ]: 'Posta Kodea'
, [ TEXT.CLIENT_ADDR_COUNTRY   ]: 'Herrialdea'


, [ TEXT.MACHINES_NEW          ]: 'Makina berria'
, [ TEXT.MACHINE_SERIAL_NO     ]: 'Serie zkia'

, [ TEXT.JOB_EDIT_TITLE        ]: 'Ataza editatu'
, [ TEXT.JOB_NEW_TITLE         ]: 'Ataza berria'
, [ TEXT.JOB_KEY_TYPE          ]: 'Modeloa'
, [ TEXT.JOB_NUM_KEYS          ]: 'Kantitatea'
, [ TEXT.JOB_MACHINE           ]: 'Makina'
, [ TEXT.JOB_STATUS            ]: 'Egoera'
, [ TEXT.JOB_DATE              ]: 'Data'
, [ TEXT.JOB_QUANTITY          ]: 'Kantitate beria'
, [ TEXT.JOB_FILTER_BY_STATUS  ]: 'Egoeraz filtratu'
, [ TEXT.JOB_FILTER_BY_CLIENT  ]: 'Bezeroz filtratu'
, [ TEXT.JOB_FILTER_BY_MACHINE_NAME ]: 'Makinaz filtratu'
, [ TEXT.JOB_FILTER_BY_KEY_TYPE]: 'Giltza motaz filtratu'
, [ TEXT.JOB_FILTER_BY_DATE    ]: 'Dataz filtratu'


, [ TEXT.KEY_MASTERING_LAUNCH             ]: 'Hasi'
, [ TEXT.KEY_MASTERING_LAUNCH_N           ]: 'Hasi ({num})'
, [ TEXT.KEY_MASTERING_NEW_TITLE          ]: 'Amaestramendua kargatu'
, [ TEXT.KEY_MASTERING_WILL_CREATE_N_KEYS ]: '{num} giltza sortuko dira. ¿Seguru zaude?'
, [ TEXT.KEY_MASTERING_KEYS_CREATED       ]: '{num} ataza sortu dira'
, [ TEXT.KEY_MASTERING_NAME               ]: 'Amaestramendu izena'

, [ TEXT.LOGIN_FORGOT_PASSWORD_QUESTION  ]: '¿Pasahitza ahaztu duzu?'
, [ TEXT.LOGIN_FORGOT_PASSWORD_TITLE     ]: 'Argibidiak hona bidali'
, [ TEXT.LOGIN_SLOGAN                    ]: 'Lainoan oinarritutako lehen giltza bikoizketa aplikazioa'
, [ TEXT.LOGIN_QUALITY_POINTS            ]: `
<br>
<br>
<p class="login-quality-call mb-4">
  <strong>THE FUTURE OF KEY DUPLICATION</strong>
</p>
  <ul class="login-sell-points">
  <li>Bezeroentzako egindako giltzen duplikatuak erregistratu</li>
  <br>
  <li>Galtzeko arrisku gabe datuak almazenatu eta edozein tokitatik atzitu</li>
  <br>
  <li>Eguneraketa automatikoak</li>
</ul>
`


, [ TEXT.LEGAL_TOS_TEXT              ]: 'Abisu legala'
, [ TEXT.LEGAL_PRIVACY_TEXT          ]: 'Pribatutasun politika'
, [ TEXT.LEGAL_MODEL_TEXT            ]: 'Akordio modeloa'
, [ TEXT.LEGAL_TOS_LINK              ]: '/legal/eu/legal_notice_eu.pdf'
, [ TEXT.LEGAL_PRIVACY_LINK          ]: '/legal/eu/privacy_policy_eu.pdf'
, [ TEXT.LEGAL_MODEL_LINK            ]: '/legal/eu/model_eu.docx'

, [ TEXT.KEY_MODEL                   ]: 'Modeloa'
, [ TEXT.KEY_SERIES                  ]: 'Seriea'
, [ TEXT.KEY_CODE                    ]: 'Kodigoa'
, [ TEXT.KEY_DATA_SHEET              ]: 'Fitxa'
, [ TEXT.KEY_BITING                  ]: 'Hortzketa'
, [ TEXT.KEY_APPLICATION             ]: 'Aplikazioa'

, [ TEXT.ENUM_JOB_STATE_PENDING      ]: 'PENDIENTE'
, [ TEXT.ENUM_JOB_STATE_CANCELLED    ]: 'KANTZELATUA'
, [ TEXT.ENUM_JOB_STATE_COMPLETE     ]: 'EGINA'
, [ TEXT.ENUM_JOB_STATE_PROCESSING   ]: 'EGINEAN'

, [ TEXT.ENUM_USER_ROLE_ADMIN        ]: 'ADMINISTRATZAILEA'
, [ TEXT.ENUM_USER_ROLE_MANAGER      ]: 'GESTOREA'
, [ TEXT.ENUM_USER_ROLE_USER         ]: 'ERABILTZAILEA'

, [ TEXT.ENUM_KEY_APP_CAR            ]: 'KOTXEA'
, [ TEXT.ENUM_KEY_APP_HOME           ]: 'ETXEA'
, [ TEXT.ENUM_KEY_APP_SECURITY       ]: 'SEGURTASUNA'
, [ TEXT.ENUM_KEY_APP_LOCK           ]: 'GILTZARRAPOA'
, [ TEXT.ENUM_KEY_APP_UNSPECIFIED    ]: 'ZEHAZTU GABE'

, [ TEXT.FORM_HAS_ERRORS             ]: 'Bete gorriz markatutako eremuak mesedez'
}

export default ES ;
